import Column from '@components/column'
import {
  StyleBannerWrapper,
  StyleBannerGrid,
  StyleBannerGridItem,
  StyleCard,
} from './style'
import Row from '@components/row'
import Circle from '@components/circle'
import Typography from '@components/typography'
import { Fragment } from 'react/jsx-runtime'
import Svg from '@components/svg'
import Image from '@components/image'
import { FC } from 'react'
interface BannerProps {
  institution: any
}

const Banner: FC<BannerProps> = ({ institution }) => {
  const items = [
    {
      title: 'Total Appointments',
      value: 5,
      icon: 'calendar',
      bg: 'green100',
    },
    {
      title: 'Upcoming Appointments',
      value: 5,
      icon: 'appointment',
      bg: 'orange100',
    },
  ]
  return (
    <Column styleColumn="position:relative">
      <StyleBannerWrapper>
        <Image
          src={`${process.env.BUCKET_URL}/${institution?.infos?.coverImage}`}
          styleImage="width:100%;height:100%"
        />
      </StyleBannerWrapper>
      <StyleBannerGrid>
        <StyleBannerGridItem>
          <StyleCard>
            <Row colGap={20} styleRow="padding:10px;">
              <Circle size={80}>
                <Image
                  fallbackType="user"
                  src={`${process.env.BUCKET_URL}/${institution?.avatar}`}
                  styleImage="width:100%;height:100%;"
                />
              </Circle>
              <Column rowGap={15}>
                <Typography content={institution?.name} tc="text" />
                <Typography
                  content={`+${institution?.countryCode} ${institution?.phoneNo}`}
                  tc="text"
                />
                <Typography content={institution?.email} tc="text" />
              </Column>
            </Row>
          </StyleCard>
        </StyleBannerGridItem>
        <StyleBannerGridItem>
          {items?.map((item: any) => {
            return (
              <Fragment key={item?.title}>
                <StyleCard>
                  <Row justifyContent="space-between">
                    <Row colGap={15} alignItems="flex-end">
                      <Column
                        styleColumn="width:40px;height:40px;border-radius:4px;"
                        justifyContent="center"
                        alignItems="center"
                        bg={item?.bg}
                      >
                        <Svg svg={item?.icon} />
                      </Column>
                      <Typography content={item?.title} size={14} />
                    </Row>
                    <Column>
                      <Typography content={item?.value} size={14} />
                    </Column>
                  </Row>
                </StyleCard>
              </Fragment>
            )
          })}
        </StyleBannerGridItem>
        <StyleBannerGridItem>
          <StyleCard>
            <Row
              alignItems="center"
              justifyContent="space-between"
              styleRow="padding:10px;height:100%;"
            >
              <Column rowGap={5}>
                <Svg svg="plusWallet" />
                <Typography
                  content="Account Not Linked!"
                  size={14}
                  weight={400}
                />
                <Typography
                  content="User has not add their account details"
                  size={12}
                  weight={300}
                />
              </Column>
              <Column>
                <Svg svg="wallet" size={50} />
              </Column>
            </Row>
          </StyleCard>
        </StyleBannerGridItem>
      </StyleBannerGrid>
    </Column>
  )
}

export default Banner
